// @flow

import * as React from 'react';

import { selectCartIsWorking } from '@gandi/cart';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Alert, Text, Choice, Fqdn, Spinner } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectOne } from '../../DomainCreate/modules/selectors/results';

import styles from './DomainRow.scss';

export type Props = {
  selectedDomain: ?string,
  suggestion: string,
  provided: boolean,
};

export function DomainRow({
  selectedDomain,
  suggestion,
  provided,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const suggestionDetails = useAppSelector(state =>
    selectOne(state, suggestion),
  );

  const notAvailableProvidedAlertMessage = (
    <p>
      {mapTags(
        __(
          'Unfortunately [[fqdn:]] is already taken. Try another name, or another extension.',
        ),
        () => ({
          fqdn: (
            <Text weight="semibold">
              <Fqdn>{suggestion}</Fqdn>
            </Text>
          ),
        }),
      )}
    </p>
  );

  const isCartWorking = useAppSelector(selectCartIsWorking);

  // we dont know how to handle it yet
  // TODO: this feature will be handle by https://phabricator.corp.gandi.net/T100865
  /**
  const notIncludedAlertMessage = (
    <p>
      {mapTags(
        __(
          'The [[extension:]] extension is not part of the free domain selection. You can, however purchase it [[domainLink:]] and use it with your hosting after purchase.'
        ),
        () => ({
          extension: (
            <Text weight="semibold">
              .{toUnicode(suggestionDetails?.tld || '')}
            </Text>
          ),
          domainLink: (
            <Link
              to={`/domain/suggest?search=${toUnicode(suggestion)}`}
            >
              {__('here')}
            </Link>
          ),
        })
      )}
    </p>
  );
  */

  return (
    <>
      {provided && suggestionDetails?.availability === 'unavailable' && (
        <Alert intent="danger" message={notAvailableProvidedAlertMessage} />
      )}

      {suggestionDetails?.availability === 'available' && (
        <Choice
          className={styles.choice}
          disabled={isCartWorking}
          value={suggestion}
        >
          <Base
            flex
            flexAlignItemsCenter
            flexJustifyBetween
            gap="xsmall"
            slot="label"
          >
            <Fqdn size="big">{suggestion}</Fqdn>{' '}
            <span>
              {isCartWorking && suggestion === selectedDomain ? (
                <Spinner name="dots" />
              ) : (
                <Text color="light" size="small">
                  {__('Free')}
                </Text>
              )}
            </span>
          </Base>
        </Choice>
      )}
    </>
  );
}
